export interface Device {
    id?: string;
    name: DeviceType;
    models?: Model[];
}

export interface Model {
    id?: string;
    equipmentId: string;
    name: string;
    code: string;
    date?: string;
    description?: string;
}

export interface VesselEquipment {
    id?: string;
    name: DeviceType;
    equipmentModelId: string;
    vesselId: string;
    designCode?: string;
    serialNumber?: string;
}

export interface EquipmentDifferences {
    created: VesselEquipment[];
    updated: VesselEquipment[];
    deleted: VesselEquipment[];
}

export enum DefaultDevices {
    FCU = 'FCU',
    FU = 'FU',
    OPS = 'OPS',
    IO = 'IO',
    CEU = 'CEU',
    EAP = 'EAP',
    IEDGE = 'iEDGE',
    KEYBOARD = 'Keyboard',
    TRACKBALL = 'Trackball',
    HUB = 'HUB',
    PRINTER = 'Printer',
}

export type DeviceType = DefaultDevices | string;
